module.exports = __webpack_public_path__ + "img/ceiling_cat.4822cd5b.png";